import { injectable } from "inversify";
import CarRepository from "../../repositories/CarRepository";

interface props { carRepository: CarRepository }

@injectable()
export default class GetCarImagesUseCase {

    _carRepository: CarRepository;

    constructor(_: props) {
        this._carRepository = _.carRepository;
    }
    async call(carId: string): Promise<string[]> {
        return await this._carRepository.getCarImages(carId);
    }
}

export const GetCarImagesUseCaseName = "GetCarImagesUseCaseName";
